import { Modal } from "antd";
import { Messages } from "../CommonMessages";
import { logoutUser } from "../../../api/loginApi";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const adnLogoutModal = (
  handleLogout,
  title = Messages.LogoutQuestion,
  okType = "danger",
  content = null
) => {
  const { confirm } = Modal;
  return confirm({
    title: title,
    content: content,
    okText: "Yes",
    okType: okType,
    cancelText: "No",
    visible: true,
    maskClosable: true,
    onOk() {
      handleLogout();
    },
  });
};
export default adnLogoutModal;
